import SizeOption from "./size-option";
import { FilterParamItem } from "../filter-param-items";
import { hide } from "../../common";

export default class SizeOptionGroup {
    private isMainGroup: boolean;
    private itemsWrapper: HTMLElement;
    private onFilterUpdated: () => void;
    private isHidden: boolean;
    private pageId: number;
    private paramId: number;
    
    private _element: HTMLElement;
    get element(): HTMLElement{
        return this._element;
    }

    private _options: SizeOption[];
    get options(): SizeOption[]{
        return this._options;
    }
    
    private _listId: string;
    get listId(): string{
        return this._listId;
    }

    private _sortValue: number;
    get sortValue(): number{
        return this._sortValue;
    }

    public static createOptionGroupElement(item: FilterParamItem, isMain: boolean) {
        const div = document.createElement('div')
        div.setAttribute('data-list-id', item.ListId.toString());
        div.setAttribute('data-is-main-group', 'true');
        div.setAttribute('data-component-part', 'group-box');
        div.setAttribute('data-sort', item.Sort.toString());

        if (isMain) {
            div.classList.add('textile-sizes');
        } 
        else {
            const h5 = document.createElement('h5');
            h5.innerText = item.Name;
            div.appendChild(h5);

            const innerDiv = document.createElement('div');
            innerDiv.setAttribute('data-component-part', 'items-wrapper');
            innerDiv.classList.add('textile-sizes');
            div.appendChild(innerDiv);
        }

        return div;
    }

    constructor(element: HTMLElement, pageId: number, paramId: number, onFilterUpdated: () => void) {
        this._element = element;
        this.onFilterUpdated = onFilterUpdated;
        this.pageId = pageId;
        this.paramId = paramId;
        this._listId = element.dataset.listId;
        this._sortValue = Number(element.dataset.sort);
        this.isMainGroup = element.dataset.isMainGroup === 'true';
        this.itemsWrapper = this.isMainGroup 
            ? this._element 
            : this._element.querySelector('[data-component-part="items-wrapper"]');
        this.initOptions();
    }

    private initOptions() {
        const options = [...this.itemsWrapper.querySelectorAll('[data-component-part="item-box"]')]
            .map(x => new SizeOption(x as HTMLElement, this.pageId, this.paramId,() => this.onFilterUpdated()));
        this._options = options;
    }

    public updateItems(items: FilterParamItem[]): void {
        const item = items.find(i => i.ListId.toString() === this._listId);

        if(!item){
            this.hide();
            if(this.options){
                this.options.forEach(o => o.hide());
            }
            return;
        } 
        
        this.show();
        if(this.options && !this.isMainGroup){
            this.addOptions(item.FilterValues.filter(f => !this.options.find(ch => ch.listId === f.ListId.toString())))
            this.options.forEach(o => o.update(item.FilterValues));
        }
    }

    private addOptions(items: FilterParamItem[]) {
        if(items.length === 0)
            return;

        const options = this.createOptions(items);
        this._options = this.options.concat(options).sort((a,b) => a.sortValue - b.sortValue);
        this.renderChildren();
    }

    private renderChildren() {
        while (this.itemsWrapper.firstChild) {
            this.itemsWrapper.removeChild((this.itemsWrapper.lastChild));
        }

        this.options.forEach(o => this.itemsWrapper.appendChild(o.element));
    }

    private createOptions(items: FilterParamItem[]): SizeOption[]{
        const options = items
            .map(i => SizeOption.CreateOptionElement(i))
            .map(e => new SizeOption(e, this.pageId, this.paramId,() => this.onFilterUpdated()));
        return options;
    }

    public hide() {
        hide(this.element);
        this.isHidden = true;
    }

    public show(): void{
        this.element.removeAttribute('style');
        this.isHidden = false;
    }
}
